var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"min-height":"250px","width":"100%","max-width":"520px","height":"auto"},attrs:{"contain":"","src":"https://grupo-cayman.com/wp-content/uploads/2022/09/promocion_moto_land.png"}})
}
var staticRenderFns = []

export { render, staticRenderFns }